module.exports = __webpack_public_path__ + "images/emoji/godmode.349eb939241a6514e49c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/godmode.png
// module id = pyYD
// module chunks = 1